export const API: any = {
  DEV: 'https://api-auto-sbx.nominasaps.com/api/v1/',
  PROD: 'https://api-next-auto.nominasaps.com/api/v1/',
  LOCAL: 'http://localhost:3000/api/v1/',
}
